export const getSiteConfig = (state) => {
	return state?.Session?.fetchConfig?.data || null;
};
